module.exports = __webpack_public_path__ + "static/img/person.2310a9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/icons/person.png
// module id = k+Fy
// module chunks = 2